import MonicaAIReviewQueue from '@nile/mangifera/src/Containers/PageContainers/MonicaAIReviewQueue';
import MonicaInsights from '@nile/mangifera/src/Containers/PageContainers/MonicaInsights';

export const WORKSPACE_MODULE_VIEWS = {
  ticket: 'ticket',
  tasks: 'tasks',
  project: 'project',
  'monica-ai': 'monica-ai'
};

export const MONICA_AI_VIEWS = [
  {
    id: 'review-queue',
    name: 'Review Queue',
    lokaliseKey: 'app.workspace.monica.view.review.queue',
    component: MonicaAIReviewQueue,
    emoji: '📈'
  },
  {
    id: 'monica-insights',
    name: 'Insights',
    lokaliseKey: 'app.workspace.monica.view.insights',
    component: MonicaInsights,
    emoji: '💫'
  }
];
